import cloneDeep from 'lodash/cloneDeep';
import difference from 'utils/difference';
import { put, fork, take, select, race } from 'redux-saga/effects';
import { takeFetch } from 'redux/helpers';
import * as serviceActions from '../../services/actions';
import * as actions from './actions';


function* updateSettings() {
  const { success } = yield takeFetch(serviceActions.api.configuration.personal.UPDATE);
  if (success) {
    const { userSettings, afterRegistration } = yield select(state => state.configuration.personal);
    yield put(actions.save.end({ origSettings: cloneDeep(userSettings) }));
    ttb.Notifications.ShowSaveSuccessMessage('Project Configuration', 'All the changes have been saved');

    if (afterRegistration) 
    {
      window.location.href = '/Backlog';
  }
  else if (success.data && success.data.isLanguageChanged)
  {
    window.setTimeout(function(){ window.location.reload(); }, 1000);
  }
  } else {
    ttb.Notifications.ShowErrorMessage('Project Configuration', 'The changes have not been saved');
  }
}

function* getPesonal() {
  const { success } = yield takeFetch(serviceActions.api.configuration.personal.GET);
  if (success) {
      yield put(actions.init.end({ userSettings: cloneDeep(success.data.userSettings), origSettings: success.data.userSettings, showMessage: success.data.showChangePasswordMessage, afterRegistration: success.data.afterRegistration }));
      if (success.data.showChangePasswordMessage) {
          ttb.Notifications.ShowSaveSuccessMessage('Change Password', 'Password has been changed');
      }
  }
}

function* init() {
  while (true) {
    yield take(actions.INIT.BEGIN);
    yield put(serviceActions.api.configuration.personal.get.request());
    yield fork(getPesonal);
  }
}

function* save() {
  while (true) {
    yield take(actions.SAVE.BEGIN);
    const { userSettings } = yield select(state => state.configuration.personal);
    yield put(serviceActions.api.configuration.personal.update.request({
      userSettings,
    }));
    yield fork(updateSettings);
  }
}

function* invalidate() {
  while (true) {
    yield race([
      take(actions.SET_FIRST_NAME),
      take(actions.SET_LAST_NAME),
      take(actions.SET_ABOUT_ME),
      take(actions.SET_AVATAR),
      take(actions.SET_RECEIVE_EMAIL),
      take(actions.SET_LANGUAGE),
      take(actions.SET_COMPANY),
      take(actions.SET_PHONE),
    ]);
    const {
      origSettings,
      userSettings,
       } = yield select(state => state.configuration.personal);
    const changes = difference(origSettings, userSettings);
    yield put(actions.invalidate({ changes }));
  }
}

function* resetChanges() {
  while (true) {
    yield take(actions.RESET_CHANGES.BEGIN);
    const {
      origSettings,
       } = yield select(state => state.configuration.personal);
    yield put(actions.resetChanges.end({ userSettings: cloneDeep(origSettings) }));
  }
}

export default function* tag() {
  yield fork(init);
  yield fork(save);
  yield fork(invalidate);
  yield fork(resetChanges);
}



// WEBPACK FOOTER //
// ../redux/store/configuration/personal/saga.js